"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var DEFAULT_LANG = 'es';
var DEFAULT_COUNTRY = 'ES';
var DEFAULT_REGION = 'SPAIN';
var GATEWAYS = {
  Stripe: 1,
  Paypal: 2,
  Braintree: 3,
  AmazonCheckout: 4,
  Klarna: 5,
  Popup: 6
};
var DEFAULT_CART = {
  cart_id: null,
  start_date: null,
  modified_date: null,
  promo_code: '',
  reward_code: null,
  number_products: 0,
  promo_code_modified: null,
  country: DEFAULT_COUNTRY,
  language: DEFAULT_LANG,
  region: DEFAULT_REGION,
  currency: 'EUR',
  totals: {},
  orderlines: [],
  presents: [],
  postalCode: null,
  totalsIsLoading: false,
  meta: {},
  address: {
    first_name: '',
    last_name: '',
    email: '',
    address: '',
    zip_code: '',
    city: '',
    lang: 'en',
    prefix_phone: '',
    phone: '',
    country: DEFAULT_COUNTRY
  },
  origin: 'vnext.cocunat.com',
  gateway: GATEWAYS.Stripe
};
var COUNTRIES = [{
  code: 'AL',
  name: 'Albania',
  lang: 'en',
  prefix: '+355'
}, {
  code: 'AM',
  name: 'Armenia',
  lang: 'en',
  prefix: '+374'
}, {
  code: 'AT',
  name: 'Austria',
  lang: 'en',
  prefix: '+43'
}, {
  code: 'AU',
  name: 'Australia',
  lang: 'en',
  prefix: '+61'
}, {
  code: 'BA',
  name: 'Bosnia and Herzegovina',
  lang: 'en',
  prefix: '+387'
}, {
  code: 'BE',
  name: 'Belgium',
  lang: 'en',
  prefix: '+32'
}, {
  code: 'BG',
  name: 'Bulgaria',
  lang: 'en',
  prefix: '+359'
}, {
  code: 'CA',
  name: 'Canada',
  lang: 'en',
  prefix: '+1'
}, {
  code: 'CO',
  name: 'Colombia',
  lang: 'es',
  prefix: '+57'
}, {
  code: 'CH',
  name: 'Switzerland',
  lang: 'en',
  prefix: '+41'
}, {
  code: 'CY',
  name: 'Cyprus',
  lang: 'en',
  prefix: '+357'
}, {
  code: 'CZ',
  name: 'Czech Republic',
  lang: 'en',
  prefix: '+420'
}, {
  code: 'DE',
  name: 'Germany',
  lang: 'de',
  prefix: '+49'
}, {
  code: 'DK',
  name: 'Denmark',
  lang: 'en',
  prefix: '+45'
}, {
  code: 'EE',
  name: 'Estonia',
  lang: 'en',
  prefix: '+372'
}, {
  code: 'ES',
  name: 'Spain (España)',
  lang: 'es',
  prefix: '+34'
}, {
  code: 'FI',
  name: 'Finland',
  lang: 'en',
  prefix: '+358'
}, {
  code: 'FO',
  name: 'Faroe Islands',
  lang: 'en',
  prefix: '+298'
}, {
  code: 'FR',
  name: 'France',
  lang: 'fr',
  prefix: '+33'
}, {
  code: 'GB',
  name: 'United Kingdom',
  lang: 'en',
  prefix: '+44'
}, {
  code: 'GE',
  name: 'Georgia',
  lang: 'en',
  prefix: '+995'
}, {
  code: 'GL',
  name: 'Greenland',
  lang: 'en',
  prefix: '+299'
}, {
  code: 'GR',
  name: 'Greece',
  lang: 'en',
  prefix: '+30'
}, {
  code: 'HR',
  name: 'Croatia',
  lang: 'en',
  prefix: '+385'
}, {
  code: 'HU',
  name: 'Hungary',
  lang: 'en',
  prefix: '+36'
}, {
  code: 'IE',
  name: 'Ireland',
  lang: 'en',
  prefix: '+353'
}, {
  code: 'IM',
  name: 'Isle of Man',
  lang: 'en',
  prefix: '+44'
}, {
  code: 'IS',
  name: 'Iceland',
  lang: 'en',
  prefix: '+354'
}, {
  code: 'IT',
  name: 'Italy',
  lang: 'it',
  prefix: '+39'
}, {
  code: 'LI',
  name: 'Liechtenstein',
  lang: 'en',
  prefix: '+423'
}, {
  code: 'LT',
  name: 'Lithuania',
  lang: 'en',
  prefix: '+370'
}, {
  code: 'LU',
  name: 'Luxembourg',
  lang: 'en',
  prefix: '+352'
}, {
  code: 'LV',
  name: 'Latvia',
  lang: 'en',
  prefix: '+371'
}, {
  code: 'MC',
  name: 'Monaco',
  lang: 'en',
  prefix: '+377'
}, {
  code: 'MD',
  name: 'Moldova',
  lang: 'en',
  prefix: '+373'
}, {
  code: 'ME',
  name: 'Montenegro',
  lang: 'en',
  prefix: '+382'
}, {
  code: 'MK',
  name: 'Macedonia',
  lang: 'en',
  prefix: '+389'
}, {
  code: 'MT',
  name: 'Malta',
  lang: 'en',
  prefix: '+356'
}, {
  code: 'NL',
  name: 'Netherlands',
  lang: 'en',
  prefix: '+31'
}, {
  code: 'NO',
  name: 'Norway',
  lang: 'en',
  prefix: '+47'
}, {
  code: 'NZ',
  name: 'New Zealand',
  lang: 'en',
  prefix: '+64'
}, {
  code: 'PL',
  name: 'Poland',
  lang: 'en',
  prefix: '+48'
}, {
  code: 'PT',
  name: 'Portugal',
  lang: 'en',
  prefix: '+351'
}, {
  code: 'RO',
  name: 'Romania',
  lang: 'en',
  prefix: '+40'
}, {
  code: 'RS',
  name: 'Serbia',
  lang: 'en',
  prefix: '+381'
}, {
  code: 'SE',
  name: 'Sweden',
  lang: 'en',
  prefix: '+46'
}, {
  code: 'SI',
  name: 'Slovenia',
  lang: 'en',
  prefix: '+386'
}, {
  code: 'SJ',
  name: 'Svalbard and Jan Mayen',
  lang: 'en',
  prefix: '+47'
}, {
  code: 'SK',
  name: 'Slovakia',
  lang: 'en',
  prefix: '+421'
}, {
  code: 'SM',
  name: 'San Marino',
  lang: 'en',
  prefix: '+378'
}, {
  code: 'US',
  name: 'United States',
  lang: 'en',
  prefix: '+1'
}, {
  code: 'XK',
  name: 'Kosovo',
  lang: 'en',
  prefix: '+383'
}, {
  code: 'PE',
  name: 'Peru',
  lang: 'es',
  prefix: '+51'
}, {
  code: 'PH',
  name: 'Phillipines',
  lang: 'en',
  prefix: '+63'
}, {
  code: 'IL',
  name: 'Israel',
  lang: 'en',
  prefix: '+972'
}, {
  code: 'SA',
  name: 'Arabia Saudi',
  lang: 'en',
  prefix: '+966'
}, {
  code: 'PR',
  name: 'Puerto Rico',
  lang: 'en',
  prefix: '+1'
}];
var STATES = {
  US: [{
    code: 'AL',
    name: 'Alabama'
  }, {
    code: 'AK',
    name: 'Alaska'
  }, {
    code: 'AZ',
    name: 'Arizona'
  }, {
    code: 'AR',
    name: 'Arkansas'
  }, {
    code: 'CA',
    name: 'California'
  }, {
    code: 'CO',
    name: 'Colorado'
  }, {
    code: 'CT',
    name: 'Connecticut'
  }, {
    code: 'DE',
    name: 'Delaware'
  }, {
    code: 'FL',
    name: 'Florida'
  }, {
    code: 'GA',
    name: 'Georgia'
  }, {
    code: 'HI',
    name: 'Hawaii'
  }, {
    code: 'ID',
    name: 'Idaho'
  }, {
    code: 'IL',
    name: 'Illinois'
  }, {
    code: 'IN',
    name: 'Indiana'
  }, {
    code: 'IA',
    name: 'Iowa'
  }, {
    code: 'KS',
    name: 'Kansas'
  }, {
    code: 'KY',
    name: 'Kentucky'
  }, {
    code: 'LA',
    name: 'Louisiana'
  }, {
    code: 'ME',
    name: 'Maine'
  }, {
    code: 'MD',
    name: 'Maryland'
  }, {
    code: 'MA',
    name: 'Massachusetts'
  }, {
    code: 'MI',
    name: 'Michigan'
  }, {
    code: 'MN',
    name: 'Minnesota'
  }, {
    code: 'MS',
    name: 'Mississippi'
  }, {
    code: 'MO',
    name: 'Missouri'
  }, {
    code: 'MT',
    name: 'Montana'
  }, {
    code: 'NE',
    name: 'Nebraska'
  }, {
    code: 'NV',
    name: 'Nevada'
  }, {
    code: 'NH',
    name: 'New Hampshire'
  }, {
    code: 'NJ',
    name: 'New Jersey'
  }, {
    code: 'NM',
    name: 'New Mexico'
  }, {
    code: 'NY',
    name: 'New York'
  }, {
    code: 'NC',
    name: 'North Carolina'
  }, {
    code: 'ND',
    name: 'North Dakota'
  }, {
    code: 'OH',
    name: 'Ohio'
  }, {
    code: 'OK',
    name: 'Oklahoma'
  }, {
    code: 'OR',
    name: 'Oregon'
  }, {
    code: 'PA',
    name: 'Pennsylvania'
  }, {
    code: 'RI',
    name: 'Rhode Island'
  }, {
    code: 'SC',
    name: 'South Carolina'
  }, {
    code: 'SD',
    name: 'South Dakota'
  }, {
    code: 'TN',
    name: 'Tennessee'
  }, {
    code: 'TX',
    name: 'Texas'
  }, {
    code: 'UT',
    name: 'Utah'
  }, {
    code: 'VT',
    name: 'Vermont'
  }, {
    code: 'VA',
    name: 'Virginia'
  }, {
    code: 'WA',
    name: 'Washington'
  }, {
    code: 'WV',
    name: 'West Virginia'
  }, {
    code: 'WI',
    name: 'Wisconsin'
  }, {
    code: 'WY',
    name: 'Wyoming'
  }]
};
var BLANK_ADDRESS = {
  first_name: '',
  last_name: '',
  email: '',
  address: '',
  zip_code: '',
  city: '',
  prefix_phone: '',
  phone: '',
  country: ''
};
var PAYPAL_ACCEPTED_CURRENCIES = ['AUD', 'BRL', 'CAD', 'CHF', 'CNY', 'CZK', 'DKK', 'EUR', 'GBP', 'HKD', 'HUF', 'ILS', 'JPY', 'MXN', 'MYR', 'NOK', 'NZD', 'PHP', 'PLN', 'RUB', 'SEK', 'SGD', 'THB', 'TWD', 'USD'];
var AMAZON_ACCEPTED_CURRENCIES = ['AUD', 'CHF', 'DKK', 'EUR', 'GBP', 'HKD', 'JPY', 'NOK', 'NZD', 'SEK', 'USD', 'ZAR'];
var TRIAL_PRODUCTS = [53300, 53308, 53301, 53302, 53303, 53305, 94, 95, 96, 53306, 53304];
var CURLY_PRODUCTS = [53009, 53055, 53060, 53109, 53110, 53114, 53115, 53117, 53134, 53165, 53291, 53292, 53296, 53293, 53295, 53294, 53297, 53272];
var CONSTANTS = {
  DEFAULT_CART: DEFAULT_CART,
  DEFAULT_LANG: DEFAULT_LANG,
  COUNTRIES: COUNTRIES,
  DEFAULT_COUNTRY: DEFAULT_COUNTRY,
  BLANK_ADDRESS: BLANK_ADDRESS,
  CURLY_PRODUCTS: CURLY_PRODUCTS,
  GOURMET_ACTIVE: [53009],
  SUBSCRIPTION_TYPES: {
    GOURMET: 'GOURMET',
    SIMPLE: 'SIMPLE'
  },
  STORE_ADDRESS: {
    address: 'Rambla Catalunya 89 local 1 (Mallorca 247)',
    city: 'Barcelona',
    zip_code: '08008',
    country: 'ES',
    prefix_phone: '+34',
    phone: '911980581'
  },
  GATEWAYS: GATEWAYS,
  STATES: STATES,
  PAYPAL_ACCEPTED_CURRENCIES: PAYPAL_ACCEPTED_CURRENCIES,
  AMAZON_ACCEPTED_CURRENCIES: AMAZON_ACCEPTED_CURRENCIES,
  TRIAL_PRODUCTS: TRIAL_PRODUCTS
};
var _default = CONSTANTS;
exports["default"] = _default;